export const TEXTURE_SOURCES = {
    normal: '/img/textile-sphere/plain-normal.webp',
    roughness: '/img/textile-sphere/plain-roughness.webp',
    diffuse: '/img/textile-sphere/plain-diffuse.webp',
    envMap: '/img/textile-sphere/plain-reflection.webp',
};
